import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {User} from '../../../graphql/auth';
import {gqlUser} from '../getUser.api';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';

export interface UpdateUserVars {
    data: {
        id: number,
        first_name?: string
        last_name?: string
        email?: string
        password?: string
        email_verified?: boolean,
        admin_verified?: boolean,
        email_opt_out?: boolean,
        sms_opt_out?: boolean,
        cellphone?: string,
        cellphone_code?: string,
        permissions?: {
            connect?: number[],
            disconnect?: number[],
        },
    };
}

interface UpdateUserData {
    __typename?: string,
    updateUser: User
}

export const UPDATE_USER_MUTATION = gql`
    mutation updateUser($data: UpdateUserInput!) {
        updateUser(data: $data) {
            ${gqlUser}
        }
    }
`;

export const updateUser = () => useMutation<UpdateUserData, UpdateUserVars>(
    UPDATE_USER_MUTATION,
    {
        update: updateCacheByType(['User', 'Permission'])
    }
);

export default updateUser;
